import { render, staticRenderFns } from "./BtnMensagemErroIntegracao.vue?vue&type=template&id=b31347e0&"
import script from "./BtnMensagemErroIntegracao.vue?vue&type=script&lang=js&"
export * from "./BtnMensagemErroIntegracao.vue?vue&type=script&lang=js&"
import style0 from "./BtnMensagemErroIntegracao.vue?vue&type=style&index=0&id=b31347e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports